var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{attrs:{"style-modifier":"text","data-test-id":"log-out-button"},on:{"click":function($event){return _vm.$emit('log-out')}}},[_c('div',{staticClass:"log-out-button"},[_c('p',{staticClass:"log-out-button__text"},[_vm._v("Cerrar Sesion")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }